import { render, staticRenderFns } from "./ListSessaoViewResumoServidor.vue?vue&type=template&id=15035b27&"
import script from "./ListSessaoViewResumoServidor.vue?vue&type=script&lang=js&"
export * from "./ListSessaoViewResumoServidor.vue?vue&type=script&lang=js&"
import style0 from "./ListSessaoViewResumoServidor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports